import StyleClass from 'primevue/styleclass';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('styleclass', StyleClass);
});
